export const getRelativeUrlWithoutLocale = (url: string, pathLocale: string) => {
    const urlWithoutLocale = url.replace(`/${pathLocale}`, '');
    return urlWithoutLocale.startsWith('/') ? urlWithoutLocale : `/${urlWithoutLocale}`;
};

export const createGetRelativeUrlWithoutRegionLocale = (locales: string[]) => {
    const getRelativeUrlWithoutRegionLocale = (url: string) => {
        const [path = ''] = url.split('?');
        const [, locale = ''] = path.split('/');
        if (locales.includes(locale)) {
            return getRelativeUrlWithoutLocale(url, locale);
        }
        return url;
    };
    return getRelativeUrlWithoutRegionLocale;
};
